//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'RuleEditor',
  props: {
    template: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    emitUnsavedChanges: function emitUnsavedChanges(template) {
      this.$emit('update-unsaved-changes', template);
    }
  }
};